import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6d04066"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "form-group mb-31" }
const _hoisted_3 = { class: "input-wrap" }
const _hoisted_4 = { class: "units" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */))

import { onMounted, ref } from 'vue'

import {
  Input,
  Error,
  Description,
  Label,
} from '@/popup/components/shared/Form/Form'
import { DEFAULT_IDLE_TIMEOUT_IN_MINUTES } from '@/shared/config'
import { InputError } from '@/popup/components/shared/Form/FormTypes'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { NUMBER_VALIDATOR } from '@/shared/regexValidator'
import { autolockNumberValidator } from '@/popup/components/shared/Form/validators'


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoLock',
  setup(__props) {

const idleTime = ref(`${DEFAULT_IDLE_TIMEOUT_IN_MINUTES}`)
const idleTimeErrors = ref<InputError[]>([])

const preferencesStore = usePreferencesStore()

const onIdleTimeUpdate = (newValue: string) => {
  idleTime.value = newValue
}
const onIdleTimeErrors = (newErrors: InputError[]) =>
  (idleTimeErrors.value = newErrors)

const onKeyPress = (event: KeyboardEvent) => {
  if (!NUMBER_VALIDATOR.test(event.key)) {
    event.preventDefault()
  }
}

const onSaveIdleTimeout = async () => {
  if (idleTimeErrors.value.length === 0 && idleTime.value) {
    await preferencesStore.setIdleTimeoutInMinutes(idleTime.value)
    await useGlobals().sendMessage({
      method: InternalMethods.KEEP_ALIVE,
      payload: undefined,
    })
  }
}

onMounted(async () => {
  const timeout = await preferencesStore.getIdleTimeoutInMinutes()
  idleTime.value = `${timeout}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Label), {
      "extra-class": "is-title mb-2",
      label: _ctx.$t('app.auto_lock_timer')
    }, null, 8 /* PROPS */, ["label"]),
    _createVNode(_unref(Description), {
      description: _ctx.$t('app.auto_lock_timer_info')
    }, null, 8 /* PROPS */, ["description"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Input), {
          name: "idleTime",
          value: idleTime.value,
          placeholder: _ctx.$t('app.auto_lock_timer_placeholder'),
          errors: idleTimeErrors.value,
          validators: [_unref(autolockNumberValidator)],
          size: "large",
          "extra-classes": "input text-input",
          "is-required": "",
          "validate-on-blur": "",
          "validate-on-load": "",
          "data-testid": "idleTime",
          onOnBlur: onSaveIdleTimeout,
          onOnUpdate: onIdleTimeUpdate,
          onOnErrors: onIdleTimeErrors,
          onOnKeyPress: onKeyPress
        }, null, 8 /* PROPS */, ["value", "placeholder", "errors", "validators"]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('app.auto_lock.minutes')), 1 /* TEXT */)
        ])
      ]),
      _createVNode(_unref(Error), {
        error: idleTimeErrors.value[0]
      }, null, 8 /* PROPS */, ["error"])
    ])
  ]))
}
}

})